import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getPageIsReady } from 'selectors/page'
import { getCanEditArtwork, getIsAdmin } from '../selectors/admin'
import { getArtistName, getArtistUserId } from '../selectors/artist'
import { getArtworkCategory } from '../selectors/artwork'
import { getCurrentTab } from '../selectors/product'

const mapStateToProps = createStructuredSelector({
  canEditArtwork: getCanEditArtwork,
  isAdmin: getIsAdmin,
  pageIsReady: getPageIsReady,
  artistName: getArtistName,
  artistUserId: getArtistUserId,
  category: getArtworkCategory,
  currentTab: getCurrentTab,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  canEditArtwork: boolean
  isAdmin: boolean
  pageIsReady: boolean
  artistName: string
  artistUserId: string
  category: string
  currentTab: string
}
export default connect(mapStateToProps, mapDispatchToProps)
